import { render, staticRenderFns } from "./cloudHomeworkStatis.vue?vue&type=template&id=5fad31b4&scoped=true"
import script from "./cloudHomeworkStatis.vue?vue&type=script&lang=js"
export * from "./cloudHomeworkStatis.vue?vue&type=script&lang=js"
import style0 from "./cloudHomeworkStatis.vue?vue&type=style&index=0&id=5fad31b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fad31b4",
  null
  
)

export default component.exports